import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import classes from "./styles.module.scss";
import PropTypes from "prop-types";
import clsx from "classnames";

export default function LatestNewsCard({ className, title, image, href, category }) {

  function getImage() {
    switch(category) {
      case "linkedin":
        return <img className={classes.social_icon} src="/linkedin.png" alt="LinkedIn" />;
      case "instagram":
        return <img className={classes.social_icon} src="/instagram.webp" alt="Instagram" />;
      case "facebook":
        return <></>;
      case "youtube":
        return <img style={{width: '70px'}} className={classes.social_icon} src="/youtube.webp" alt="YouTube" />;
      case "twitter":
        return <img style={{height: '20px', width: '20px'}} className={classes.social_icon} src="/twitter.svg" alt="Twitter" />;
      default:
        return <img className={classes.social_icon} src="/linkedin.png" alt="LinkedIn" />;
    }
  }

  return (
    <a href={href} className={clsx(className, classes.card)}>
      {getImage()}
      <div className={classes.subcard}>
        {
          image ? 
          <div>
            <SourceFlowImage className={classes.image} src={image} size="100x100" alt={title} />
          </div> : <></>
        }
        <div className={classes.body}>
          {title}
        </div>
      </div>
    </a>
  );
}

LatestNewsCard.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  img: PropTypes.string,
  published_at: PropTypes.string,
};
